const PIXEL_ID = '1090506239842687'

let pixelInitialized = false

export function initMetaPixel() {
  if (pixelInitialized) return
  try {
    import('react-facebook-pixel')
      .then((module) => {
        const ReactPixel = module.default
        ReactPixel.init(PIXEL_ID, undefined, {
          autoConfig: true,
          debug: false,
        })
        ReactPixel.pageView()
        pixelInitialized = true
      })
      .catch(() => {
        // Pixel library not available in this environment
      })
  } catch {
    // Pixel initialization failed — will work on deployed site
  }
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  try {
    import('react-facebook-pixel')
      .then((module) => {
        module.default.track(event, data)
      })
      .catch(() => {})
  } catch {
    // silent fail
  }
}

export function trackCustomEvent(
  event: string,
  data?: Record<string, unknown>,
) {
  try {
    import('react-facebook-pixel')
      .then((module) => {
        module.default.trackCustom(event, data)
      })
      .catch(() => {})
  } catch {
    // silent fail
  }
}
